import API from '../../../api/endpoints'
import IEHackMixin from '../../helpers/IEHackMixin'
export default {
  data () {
    return {
      locationSearchText: '',
      locationSearchResults: [],
      partySearchText: '',
      partySearchResults: []
    }
  },
  mixins: [IEHackMixin],
  watch: {
    locationSearchText (newVal, oldVal) {
      if (newVal.trim().length > 1) {
        this.updateLocationSearchResults(newVal)
      }
    },
    partySearchText (newVal, oldVal) {
      if (newVal.trim().length > 1) {
        this.updatePartySearchResults(newVal)
      }
    }
  },
  methods: {
    deCamel (string) {
      return string.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
    },
    getDefault (optionTypeName) {
      let option = null
      this.systemOptions.every(({optionType, code, valueAlpha}) => {
        if (optionType !== null && optionType.hasOwnProperty('code') && optionType.code === 'DEFAULT' && code === optionTypeName) {
          option = valueAlpha
          return false
        }
        return true
      })
      this.systemOptions.every(o => {
        if (o.hasOwnProperty('optionType') && o.optionType !== null && o.optionType.hasOwnProperty('code') && o.optionType.code === optionTypeName && o.code === option) {
          option = o
          return false
        }
        return true
      })
      return option
    },
    updatePartySearchResults (str) {
      let nameSearch = this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('party'), { params: { name: str }, headers: { 'X-Lazy-Fetch': '0' } })
      let codeSearch = this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('party'), { params: { code: str }, headers: { 'X-Lazy-Fetch': '0' } })
      Promise.all([nameSearch, codeSearch])
      .then(res => {
        if (str === this.partySearchText) {
          this.partySearchResults = [...res[0].body, ...res[1].body]
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },
    unwrapData (obj, propsToUnbox = false) {
      let data = {}
      for (let prop in obj) {
        if (typeof obj[prop] === 'object' && obj[prop] !== null && obj[prop].hasOwnProperty('id') && (!propsToUnbox || propsToUnbox.includes(prop))) {
          data[prop] = obj[prop].id
        } else {
          data[prop] = obj[prop]
        }
      }
      return data
    },
    displayParty (p) {
      let str = `${p.name}, ${p.code}`
      if (p.address !== null) {
        str += `, ${p.address.subdivision}`
        if (p.address.country !== null) {
          str += `, ${p.address.country.code}`
        }
      }
      return str
    },
    displayLocation (location) {
      let str = ''
      if (location.name) {
        str += location.name
      }
      if (location.subdivision) {
        str += `, ${location.subdivision}`
      }
      if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
        str += `, ${location.country.code}`
      }
      if (location.category === 'VENDOR_ZONE') {
        str += ' (VZ)'
      }
      return str
    },
    updateLocationSearchResults (str) {
      this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('location'), { params: { name: str } })
        .then(({data}) => {
          if (str === this.locationSearchText) {
            this.$store.dispatch('quote/mapLocationsWithCountry', data)
            .then(res => {
              this.locationSearchResults = res
            })
            .catch(err => {
              console.log(err)
              this.locationSearchResults = data
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getSystemOptions (code) {
      return this.systemOptions.filter(({optionType}) => {
        return optionType !== null && optionType.hasOwnProperty('code') && optionType.code === code
      })
    },
    getSystemOption (oId) {
      const index = this.systemOptions.findIndex(({id}) => oId === id)
      if (index > -1) {
        return this.systemOptions[index]
      } else {
        return ''
      }
    },
    getSystemOptionParameter (whichCode) {
      const index = this.systemOptions.findIndex(({code, optionType}) => code === whichCode && optionType && optionType.code === 'PARAMETER')
      if (index > -1) {
        return this.systemOptions[index]
      } else {
        return ''
      }
    },
    isSystemOptionParameterEnabled (whichCode) {
      const param = this.getSystemOptionParameter(whichCode)
      return param && param.valueBoolean === 1
    },
    sortedOptions (code) {
      return this.getSystemOptions(code).sort((a, b) => {
        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      })
    }
  },
  computed: {
    systemOptions () {
      return this.$store.getters['systemOption/options']
    },
    countries () {
      return this.$store.getters['systemOption/countries']
    },
    ports () {
      return this.locationSearchResults.filter(({category}) => category === 'PORT')
    },
    currencies () {
      return this.$store.getters['systemOption/currencies']
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/mixins/Helpers.js